/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const KeyNotEqualAnnotationKeyAnnotationValue: core.serialization.ObjectSchema<
    serializers.KeyNotEqualAnnotationKeyAnnotationValue.Raw,
    Truvity.KeyNotEqualAnnotationKeyAnnotationValue
> = core.serialization.object({
    key: core.serialization.string(),
    value: core.serialization.string(),
});

export declare namespace KeyNotEqualAnnotationKeyAnnotationValue {
    export interface Raw {
        key: string;
        value: string;
    }
}
